import React from "react";
import classes from "./styles/style.module.css";

const RbBlogFilter = ({ selected, handleSelect, query }) => {
  return (
    <div className={classes.blogFiltersContainer}>
      <div
        onClick={() => handleSelect(query ? query : "RaheBehesht1403")}
        className={`${classes.BlogFilter} ${
          selected === "RaheBehesht1403" || selected === query
            ? classes.selectedFilter
            : ""
        }`}
      >
        همه
      </div>
      <div
        onClick={() => handleSelect("عصرگاه_بهشتی")}
        className={`${classes.BlogFilter} ${
          selected === "عصرگاه_بهشتی" ? classes.selectedFilter : ""
        }`}
      >
        عصرگاه بهشتی
      </div>
    </div>
  );
};

export default RbBlogFilter;
